import script from "./CertificationsNavbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificationsNavbar.vue?vue&type=script&setup=true&lang=ts"

import "./CertificationsNavbar.vue?vue&type=style&index=0&id=1a69928c&scoped=true&lang=css"
import "@/assets/css/certifications/certification-form.css?vue&type=style&index=1&id=1a69928c&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a69928c"]])

export default __exports__